import { API } from "@/services";
import { FETCH_USER } from "../constants/actions";
import { GET_USER } from "../constants/getters";
import { SET_USER } from "../constants/mutations";
export default {
  state: {
    user: {},
  },
  getters: {
    [GET_USER](state){ return state.user }
  },
  actions: {
    async [FETCH_USER](context){
      const { data } = await API.endpoints.users.findMe()
      context.commit(SET_USER,data)
    },
  },
  mutations: {
    [SET_USER](state,value){
      state.user=value ?? {}
    },
  },
};